var _excluded = ["total", "page", "pageSize", "pageSizeOptions", "onChange", "PaginationProps"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState } from 'react';
import { Box, MenuItem, Pagination as MuiPagination, Select, Stack, styled, TextField } from '@mui/material';
var PaginationRoot = styled(Stack, {
  name: 'pagination',
  slot: 'root'
})(function () {
  return {
    fontSize: '14px'
  };
});
var Pagination = function Pagination(props) {
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    push = _useState2[0],
    setPush = _useState2[1];
  var total = props.total,
    _props$page = props.page,
    page = _props$page === void 0 ? 1 : _props$page,
    _props$pageSize = props.pageSize,
    pageSize = _props$pageSize === void 0 ? 20 : _props$pageSize,
    _props$pageSizeOption = props.pageSizeOptions,
    pageSizeOptions = _props$pageSizeOption === void 0 ? [10, 20, 50, 100] : _props$pageSizeOption,
    _onChange = props.onChange,
    PaginationProps = props.PaginationProps,
    other = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(PaginationRoot, _extends({
    justifyContent: "space-between",
    alignItems: "center",
    direction: "row"
  }, other), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Select, {
    size: "small",
    value: pageSize,
    onChange: function onChange(e) {
      var _props$onChange;
      return (_props$onChange = props.onChange) === null || _props$onChange === void 0 ? void 0 : _props$onChange.call(props, 1, e.target.value);
    }
  }, pageSizeOptions.map(function (size) {
    return /*#__PURE__*/React.createElement(MenuItem, {
      value: size,
      key: size
    }, size);
  })), /*#__PURE__*/React.createElement(Box, {
    sx: {
      ml: '12px',
      color: 'text.auxiliary'
    },
    component: "span"
  }, "\u6761\u6BCF\u9875, \u5171 ", total, " \u6761")), /*#__PURE__*/React.createElement(Stack, {
    alignItems: "center",
    direction: "row",
    spacing: '12px'
  }, /*#__PURE__*/React.createElement(MuiPagination, _extends({
    count: Math.ceil(total / pageSize),
    page: page,
    onChange: function onChange(e, v) {
      return _onChange === null || _onChange === void 0 ? void 0 : _onChange(v, pageSize);
    },
    color: "primary"
  }, PaginationProps)), /*#__PURE__*/React.createElement(Stack, {
    alignItems: "center",
    direction: "row",
    sx: {
      color: 'text.auxiliary'
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "pre-input-text"
  }, "\u8DF3\u81F3"), /*#__PURE__*/React.createElement(TextField, {
    autoComplete: "off",
    value: push,
    size: "small",
    onChange: function onChange(v) {
      return setPush(v.target.value.replace(/[^0-9]/g, ''));
    },
    onKeyUp: function onKeyUp(v) {
      return v.code === 'Enter' ? _onChange === null || _onChange === void 0 ? void 0 : _onChange(Number(push), pageSize) : null;
    },
    sx: {
      width: '59px',
      margin: ' 0 8px',
      '& .MuiInputBase-root': {
        borderRadius: '8px'
      }
    }
  }), /*#__PURE__*/React.createElement("span", {
    className: "aft-input-text"
  }, "/ ", Math.ceil(total / pageSize), " \u9875"))));
};
export default Pagination;